const indexItems = [
  { label: '国产剧全集', desc: '都市、古装、悬疑、言情，经典与新作一网打尽', count: '500+' },
  { label: '韩剧全集', desc: '浪漫爱情、悬疑推理、职场律政，热门韩剧每日更新', count: '300+' },
  { label: '最新电视剧', desc: '实时同步卫视与平台首播剧集，追剧永不错过', count: '每日更新' },
  { label: '高分推荐', desc: '豆瓣8分以上品质好剧精选，告别剧荒', count: '200+' },
  { label: '热播榜单', desc: '实时热度排行，发现全网最受欢迎的电视剧', count: 'TOP50' },
  { label: '完结好剧', desc: '全集上线一次性追完，畅快观剧体验', count: '1000+' },
  { label: '经典重温', desc: '那些年追过的经典好剧，随时回味', count: '500+' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          按类型快速找到你想看的电视剧
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-5 cursor-pointer hover:bg-white transition-colors duration-200 group ${
                idx === 0 ? 'sm:col-span-2' : ''
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-150">
                  {item.label}
                </h3>
                <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}